module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_8.23e4cb6b.png";